

import { useQuery } from "@tanstack/react-query";
import type { StoreAdminStatsResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreStatsQueryParams = {
  storeId: string;
};

export function useStoreStatsQuery({ storeId }: UseStoreStatsQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeStats(storeId),
    queryFn: () => apiJsonClient<StoreAdminStatsResponse>(endpoints.admin.storeStats(storeId)),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
